
// src/Service/api.js
import axios from 'axios';

const api = axios.create({
  baseURL: '/pos',
});

api.interceptors.request.use(config => {
  const tenantId = localStorage.getItem('tenantId');
  const token = localStorage.getItem('sessionToken');
  if (tenantId) config.headers['X-TENANTID'] = tenantId;
  if (token) config.headers['Authorization'] = token;
  return config;
});


// ✅ New helper: heartbeat check (does not extend session)
export const validateSession = async () => {
  const token = localStorage.getItem('sessionToken');
  if (!token) return false;
  try {
    const res = await api.get(`/validate?token=${token}`);
    // Backend can return remaining time or success
    return res.data.code === 1; // true if session active
  } catch {
    return false;
  }
};

export default api;

